module.exports = __webpack_public_path__ + "static/img/add_menu_edit_no_image.0462acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add_menu_edit_no_image.png
// module id = 7Esd
// module chunks = 1